import { defineEntity, custom, lifecycle } from './_helpers.js';

export default defineEntity('bia', {
    submitted: lifecycle(),
    completed: custom({ scope: 'state' }),
    reviewDue: lifecycle(),
    'risk.linked': custom({ scope: 'state' }),
    'risk.unlinked': custom({ scope: 'state' }),
    'process.linked': custom({ scope: 'state' }),
    'process.unlinked': custom({ scope: 'state' }),
    'asset.linked': custom({ scope: 'state' }),
    'asset.unlinked': custom({ scope: 'state' }),
    'vendor.linked': custom({ scope: 'state' }),
    'vendor.unlinked': custom({ scope: 'state' }),
    'recoveryResource.linked': custom({ scope: 'state' }),
    'recoveryResource.unlinked': custom({ scope: 'state' }),
    'document.linked': custom({ scope: 'state' }),
    'document.unlinked': custom({ scope: 'state' }),
    'bcp.linked': custom({ scope: 'state' }),
    'bcp.unlinked': custom({ scope: 'state' }),
});
